/**
 * UILayer — fixed-camera UI layer management.
 *
 * UI elements are added to a separate container that doesn't scroll
 * with the world camera. Handles showing/hiding groups of UI elements
 * for different game states.
 */

declare const Phaser: any;

import { Depth } from "./Depth";

export class UILayer {
  public container: any;
  private scene: any;
  private groups: Map<string, any[]> = new Map();

  constructor(scene: any) {
    this.scene = scene;
    this.container = scene.add.container(0, 0);
    this.container.setScrollFactor(0);
    this.container.setDepth(Depth.SYSTEM);
  }

  /**
   * Add a display object to the UI layer, optionally in a named group.
   */
  add(obj: any, group?: string): any {
    this.container.add(obj);
    if (group) {
      if (!this.groups.has(group)) {
        this.groups.set(group, []);
      }
      this.groups.get(group)!.push(obj);
    }
    return obj;
  }

  /**
   * Show all objects in a named group.
   */
  showGroup(group: string): void {
    const items = this.groups.get(group);
    if (items) {
      items.forEach((obj) => (obj.visible = true));
    }
  }

  /**
   * Hide all objects in a named group.
   */
  hideGroup(group: string): void {
    const items = this.groups.get(group);
    if (items) {
      items.forEach((obj) => (obj.visible = false));
    }
  }

  /**
   * Create a text element on the UI layer.
   */
  text(
    x: number,
    y: number,
    content: string,
    style?: any,
    group?: string
  ): any {
    const t = this.scene.add.text(x, y, content, style);
    return this.add(t, group);
  }

  /**
   * Create a rectangle on the UI layer.
   */
  rect(
    x: number,
    y: number,
    w: number,
    h: number,
    color: number,
    group?: string
  ): any {
    const r = this.scene.add.rectangle(x, y, w, h, color);
    return this.add(r, group);
  }
}
